import Cookies from 'js-cookie';
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/effect-fade';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import all from 'gsap/all';
import Plyr from 'plyr';

const player = new Plyr('#player', {
    enabled: true,
    controls: [
        'play-large', // The large play button in the center
        'play', // Play/pause playback
        'progress', // The progress bar and scrubber for playback and buffering
        'current-time', // The current time of playback
        'captions', // Toggle captions
        'settings', // Settings menu
        'pip', // Picture-in-picture (currently Safari only)
        'airplay', // Airplay (currently Safari only)
        'fullscreen', // Toggle fullscreen
    ]
});

function activityBar() {
    function setCookie(name, value, lifetime_days) {
        var exp = new Date();
        exp.setDate(new Date().getDate() + lifetime_days);
        document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        if (document.cookie) {
            var regex = new RegExp(escape(name) + '=([^;]*)', 'gm'),
                matches = regex.exec(document.cookie);
            if (matches) {
                return matches[1];
            }
        }
    }
    jQuery("body").on('click', '.notification .close', function () {
        Cookies.set('notify', '1', { expires: 1, path: '' })
        var nav = jQuery('.notification').outerHeight();
        console.log('-' + nav + 'px');
        jQuery('#pusher').css('margin-top', '-' + nav + 'px');
        jQuery('.notification').slideUp(200);
    });
}

function PopUp() {
    jQuery("body").on('click', '.god-is-love, .overlay, .god-is-king .close', function () {
      jQuery('body').toggleClass('pop-up-open');
    });
}

jQuery(document).on('touchstart', function() {
  jQuery('body').addClass('on-mobile-device');
});

jQuery(document).ready(function () {
  if (jQuery('#exit-pop-up-holder').length > 0) {
    var popup = jQuery('#exit-pop-up-holder');
    var popupShown = false;
    var popupActivated = false;

    // Stel een timer in om de exit-intent pas na 5 seconden te activeren
    setTimeout(function() {
      popupActivated = true;
    }, 5000);

    if (Cookies.get('exit_popup') !== 'closed') {

      // Functie om popup te tonen
      function showPopup() {
        if (popupActivated && !popupShown) {
          jQuery(popup).css("display", "flex").fadeIn();
          popupShown = true;
          Cookies.set('exit_popup', 'closed', { expires: 7 });
        }
      }

      // Voeg een timer toe om de pop-up na 30 seconden te tonen
      setTimeout(function() {
        if (jQuery('body').hasClass('on-mobile-device')) {
          showPopup();
        }
      }, 30000);

      // Functie om de scrollsnelheid te detecteren
      function detectScrollSpeed() {
        var lastPosition = null;
        var delta = 0;
        var delay = 50;
        var timer;

        function clear() {
          lastPosition = null;
          delta = 0;
        }

        return function () {
          var newPosition = window.scrollY;
          if (lastPosition !== null) {
            delta = newPosition - lastPosition;
          }
          lastPosition = newPosition;

          clearTimeout(timer);
          timer = setTimeout(clear, delay);

          return delta;
        };
      }

      // Functie om te controleren of de popup moet worden getoond op basis van scrollsnelheid
      function handleScroll() {
        if (jQuery('body').hasClass('on-mobile-device')) {
          if (popupActivated && !popupShown && getScrollSpeed() < -200) {
            showPopup();
          }
        }
      }

      // Initialiseer de detectie van scrollsnelheid
      var getScrollSpeed = detectScrollSpeed();

      // Voeg de scroll detectie toe als listener voor het scrollen
      jQuery(document).on('scroll', handleScroll);

      // Detecteer muisbeweging naar de bovenkant van het scherm
      jQuery(document).on('mousemove', function (event) {
        if (popupActivated && !popupShown && event.clientY <= 10) {
          showPopup();
        }
      });
    }

    jQuery('#exit-pop-up-bg, .exit-pop-up-close').click(function () {
      jQuery(popup).fadeOut();
    });
  }
});

function NewsSwiper() {
    const news = new Swiper('.news-swiper', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 2,
        spaceBetween: 16,
        clickable: true,
        speed: 1000,
        breakpoints: {
            575: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {

                slidesPerView: 3,
                spaceBetween: 30,
            },
            1500: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
        navigation: {
            nextEl: '.next-slide',
        },
    });
}


function recommendedLessons() {
    const lessons = new Swiper('.recommended-lessons', {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 2,
        spaceBetween: 16,
        clickable: true,
        speed: 800,
        breakpoints: {
            575: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            768: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {

                slidesPerView: 3,
                spaceBetween: 30,
            },
            1500: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
        navigation: {
            nextEl: '.next-l',
            prevEl: '.prev-l',
        },
    });
}

function ReadMore() {
    jQuery('.el').readmore({
        speed: 75,
        lessLink: '<a href="#" class=" me-3 read-more">Toon minder</a>',
        moreLink: '<a href="#" class=" me-3 read-more">Lees het hele verhaal</a>',
        collapsedHeight: 240,
    });
}

function FaqItems() {
    jQuery("body").on('click', '.faq-item', function () {
        jQuery('html, body').animate({
            scrollTop: jQuery("#faq").offset().top
        }, 200);
        jQuery('.faq-item.active').removeClass('active');
        jQuery('.faq.active').removeClass('active');
        jQuery(this).addClass('active');
        var vacancyItem = jQuery(this).attr('item')
        jQuery('#' + vacancyItem).addClass('active');
    });
}

function Share() {
    jQuery(".shareBlock").each(function () {
        jQuery(this).cShare({
            show_buttons: [
                'fb',
                'twitter',
                'linkedin',
                'whatsapp',
                'email',
            ]
        });
    });
}

function hamburgerMenu() {
    jQuery("body").on('click', '.hamburger-toggle', function () {
        jQuery('body').toggleClass('menu-is-open');
    });
}

activityBar()
FaqItems()
PopUp()
NewsSwiper()
ReadMore()
Share()
recommendedLessons()
hamburgerMenu()



jQuery("body").on('click touchstart', '.play-pause-button', function () {
    jQuery('.plyr__control[data-plyr="play"]').get(0).click();
    jQuery('body').toggleClass('full-screen');
    document.body.classList.add('show-pause-button');
});

jQuery('.information').readmore({
    speed: 75,
    lessLink: '<a href="#" class="d-block pt-4 me-3 read-more-informtion">Verbergen</a>',
    moreLink: '<a href="#" class="d-block pt-4 me-3 read-more-informtion">Meer informatie</a>',
    collapsedHeight: 80,
});



var idleTime = 4000; // Time in milliseconds to consider cursor idle

var timer;
var body = document.body;

function addPauseButtonClass() {
    body.classList.add('hide-pause-button');
}

function removePauseButtonClass() {
    body.classList.remove('hide-pause-button');
}

function resetTimer() {
    clearTimeout(timer);
    timer = setTimeout(addPauseButtonClass, idleTime);
}

document.addEventListener('mousemove', function () {
    removePauseButtonClass();
    resetTimer();
});

resetTimer();
